import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Close from '../common/Icons/Close';
import { isLateSubmission } from '../../utils/isLateSubmission';
import { UploadedFileDetails as Wrapper } from '../common/AssignmentPageLayout/AssignmentPageLayout';
import { DateOrderFix } from '../../utils/dateToCommonFormat';
import AssignmentContext from '../common/AssignmentContext/AssignmentContext';
import * as Styles from './SubmissionPanel.styled';

const UploadedFileDetails = ({
  attachment,
  isSubmitted,
  submittedOn,
  dueOn,
  toggleRemovePrompt,
}) => {
  const { t } = useTranslation();
  const {
    assignmentData: { assignmentType },
  } = useContext(AssignmentContext);
  const assignmentTypeForPendoClass = assignmentType
    .split('_')
    .join('-')
    .toLowerCase();
  return (
    <Wrapper isSubmitted={isSubmitted} data-testid="uploaded-file-details">
      <span>{attachment.fileName}</span>
      {isSubmitted ? (
        submittedOn && (
          <Styles.SubmittedOn>
            {t('Submitted on')}{' '}
            <DateOrderFix data-testid="upload-file-details-submitted-date">
              {submittedOn}
            </DateOrderFix>
            {submittedOn &&
              dueOn &&
              isLateSubmission(dueOn, submittedOn) && (
                <Styles.LateSubmissionIcon
                  color={'#B90330'}
                  size={20}
                  data-testid={'submitted-late-icon'}
                />
              )}
          </Styles.SubmittedOn>
        )
      ) : (
        <Styles.RemoveAttachmentButton
          onClick={toggleRemovePrompt}
          data-testid="remove-attached-file"
          className={`data-analytics-${assignmentTypeForPendoClass}-replace-attached-file`}
        >
          <Close color="#485465" size={20} />
        </Styles.RemoveAttachmentButton>
      )}
    </Wrapper>
  );
};

UploadedFileDetails.defaultProps = {
  submittedOn: null,
};

UploadedFileDetails.propTypes = {
  attachment: PropTypes.object.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  submittedOn: PropTypes.string,
  dueOn: PropTypes.string.isRequired,
  toggleRemovePrompt: PropTypes.func.isRequired,
};

export default UploadedFileDetails;
